import { SupplierCatalogConfig, currency, emptyColumn, text } from '../SupplierCatalog/supplierCatalogTypes'
import { CarahsoftCatalogRow, contractLabel } from './carahsoftTypes'
import { carahsoftPartFields } from './carahsoftPartFields'
import { carahsoftItemToLineItem } from './carahsoftLineItemMapping'

export const carahsoftCatalogConfig: SupplierCatalogConfig<CarahsoftCatalogRow> = {
  supplier: 'Carahsoft',
  endpoint: '/carahsoft/catalog',
  rowKey: row => row.priceId ?? '',
  partNumber: row => text(row.carahsoftPartNumber),
  columns: [
    { label: 'Manufacturer', className: 'supplier-catalog-col-manufacturer', render: row => text(row.vendor) },
    { label: 'Mfr Part #', className: 'supplier-catalog-col-mfr-part', render: row => text(row.vendorPartNumber) },
    { label: 'Description', className: 'supplier-catalog-col-description', render: row => text(row.description) },
    {
      label: 'Contract',
      className: 'supplier-catalog-col-contract',
      render: row => text(contractLabel(row.contract)),
    },
    { label: 'IMPRES Price', className: 'supplier-catalog-col-impres-price', align: 'right', render: emptyColumn },
    { label: 'MSRP', className: 'supplier-catalog-col-msrp', align: 'right', render: row => currency(row.listPrice) },
    { label: 'Product Category', className: 'supplier-catalog-col-product-category', render: emptyColumn },
    { label: 'Country of Origin', className: 'supplier-catalog-col-country', render: row => text(row.countryOfOrigin) },
    { label: 'TAA', className: 'supplier-catalog-col-taa', render: emptyColumn },
  ],
  drawerFields: carahsoftPartFields,
  toLineItem: (lineNumber, row) => carahsoftItemToLineItem(lineNumber, row.vendorPartNumber ?? '', row),
}
